import {ListRole} from "@/api/role";

const state = () => ({
  roles: []
})

// getters
const getters = {}

// actions
const actions = {
  async fetchRoles( { commit, dispatch } ) {
    await dispatch("loading/setLoading", true, {root: true})
    ListRole().then((data) => {
      commit('setRoles', data.data.data)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
}

// mutations
const mutations = {
  setRoles (state, roles) {
    state.roles = roles
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
